import { useSelector } from "react-redux";

const useEnabledModules = () => {
  let { enabledModules } = useSelector((state: any) => state.organization.org);
  const moduleHandle = (module: string[]) => {
    let checkModules = module.some((r) => enabledModules?.includes(r));
    return checkModules;
  };

  return {
    moduleHandle,
  };
};
export default useEnabledModules;
